import { COMPONENTS } from '../../../components/components.registry';
import { RelatedTagsConfig } from '../../../models';

export const DEFAULT_RELATED_TAGS_CONFIG: RelatedTagsConfig = {
  components: {
    panel: COMPONENTS.PANELS.SlidingPanel,
    leftIcon: COMPONENTS.PURE.ChevronLeftIcon,
    rightIcon: COMPONENTS.PURE.ChevronRightIcon,
    relatedTags: {
      container: COMPONENTS.PURE.RelatedTags,
      tag: COMPONENTS.PURE.Tag,
      selectedTagContent: COMPONENTS.PURE.CrossIcon,
      unselectedTagContent: null
    },
    selectedRelatedTags: {
      container: COMPONENTS.PURE.RelatedTags,
      tag: COMPONENTS.PURE.Tag,
      selectedTagContent: COMPONENTS.PURE.CrossIcon
    }
  },
  selectable: false,
  relatedTags: {
    showScrollButtons: false,
    showSelectedValues: true,
    animation: 'slide-bottom'
  },
  selectedRelatedTags: {
    animation: 'slide-top'
  }
};
